import React, { useRef, useEffect, useState } from "react";
import { Link } from "gatsby";
import Button from "../Button/index";
import styles from "./style.module.scss";
import ExpansionPanel from "../ExpansionPanel";
import WhyUs from "./WhyUs";
import steps from "./steps.jsx";
import Banner from "./Banner";

export default function HowItWorks({ data }) {
  const [active, setActive] = useState(0);
  const [width, setWidth] = useState(null);

  const isActive = index => index === active;

  const refs = steps.reduce((acc, value) => {
    acc[value.id] = useRef();
    return acc;
  }, {});

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleClick = id =>
    refs[id].current.scrollIntoView({
      behavior: "smooth",
      block: "center"
    });

  const handleScroll = () => {
    setActiveSection();
  };

  const setActiveSection = () => {
    const percentages = Object.keys(refs).map(i =>
      calculatePercentInViewport(refs[i])
    );
    const index = percentages.indexOf(Math.max(...percentages));
    setActive(index);
  };

  const handleResize = () => {
    setWidth(window.innerWidth);
  };

  const calculatePercentInViewport = ref => {
    const { top, bottom, height } = ref.current.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    if (top < 0 || bottom > windowHeight) {
      const offsetTop = 0 - top;
      const offsetBottom = bottom - windowHeight;
      return offsetTop > 0
        ? (height - offsetTop) / height
        : (height - offsetBottom) / height;
    }

    return 1;
  };

  const NavItem = ({ step }) => (
    <span
      className={isActive(step.id) && styles.active}
      onClick={() => handleClick(step.id)}
    >
      {`${step.id + 1}. ${step.shortTitle}`}
    </span>
  );

  return (
    <div className={styles.container}>
      <Banner />
      <div className={styles.navigation}>
        {width < 675 ? (
          <NavItem step={steps[active]} />
        ) : (
          steps.map(step => <NavItem step={step} />)
        )}
        <div className={styles.button}>
          <Link to="/new-order">
            <Button nowrap>Get Started</Button>
          </Link>
        </div>
      </div>
      <div className={styles.body}>
        {steps.map((step, index) => (
          <div className={styles.step} ref={refs[step.id]}>
            <div className={styles.number}>
              <span>{index + 1}</span>
            </div>
            <div className={styles.description}>
              <h2>{step.title}</h2>
              <div className={styles.divider} />
              <p>{step.content}</p>
              <div className={styles.expansion}>
                {step.questions &&
                  step.questions.map(question => (
                    <div>
                      <ExpansionPanel
                        title={question.title}
                        content={question.content}
                      />
                    </div>
                  ))}
              </div>
            </div>
          </div>
        ))}
        <div className={styles.whyUs}>
          <WhyUs />
        </div>
        <div className={styles.button}>
          <Link to="/new-order">
            <Button>Get Started</Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
